import React from "react";
import CapaCreateForm from "./CapaCreateForm";

/**
 * Embedded Create CAPA dialog — keeps the user on the current page (ISF, Study list, etc.).
 */
const CapaCreateModal = ({
  open,
  context,
  titleId = "capa-create-modal-title",
  onClose,
  onSaved,
}) => {
  if (!open || !context) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
      style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1200 }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id={titleId}>
              Create CAPA
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onClose}
            />
          </div>
          <div className="modal-body">
            <CapaCreateForm
              key={context.entityId}
              context={context}
              variant="modal"
              onCancel={onClose}
              onSaved={onSaved}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CapaCreateModal;
